import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Anamnese from './components/Anamnese';

function App() {
  const [isAnamneseOpen, setIsAnamneseOpen] = useState(false);
  const [preselectedService, setPreselectedService] = useState(null);

  const handleOpenAnamnese = (serviceId = null) => {
    setPreselectedService(serviceId);
    setIsAnamneseOpen(true);
  };

  return (
    <div className="App">
      <Header onOpenAnamnese={handleOpenAnamnese} />
      <Hero onOpenAnamnese={handleOpenAnamnese} />
      <Services onOpenAnamnese={handleOpenAnamnese} />
      <About />
      <Testimonials />
      <Contact onOpenAnamnese={handleOpenAnamnese} />
      <Footer />
      <Anamnese 
        isOpen={isAnamneseOpen} 
        onClose={() => {
          setIsAnamneseOpen(false);
          setPreselectedService(null);
        }}
        preselectedService={preselectedService}
      />
    </div>
  );
}

export default App;